
export default {
  data() {
    return {
      title: "Accessibility | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "accessibility",
          name: "accessibility",
          content:
            "We strives to make our website accessible for everyone, including those with disabilities. To that end, we have taken steps to improve our website’s usability for all customers including those who utilize assistive technology.",
        },
      ],
    };
  },
};
